// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TAykd,.H7Ucp{text-decoration:underline;text-underline-offset:3px}.H7Ucp{color:var(--anchore-color-blue-400)}.H7Ucp:focus-visible,.H7Ucp:hover{color:var(--anchore-color-blue-700)}.TAykd{color:inherit}.TAykd:hover{opacity:.7}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"muted": `TAykd`,
	"underline": `H7Ucp`
};
module.exports = ___CSS_LOADER_EXPORT___;
